// Mock data for container image comparisons
import nginx_latest_data from './nginx_latest_data.json';
import python_3_13_3_data from './python_3_13_3_data.json';
import python_latest_data from './python_latest_data.json';
import node_22_data from './node-22_data.json';

export const containerImages = [
  python_latest_data,
  python_3_13_3_data,
  nginx_latest_data,
  node_22_data,
];